import { IBasicEntity } from './i-basic-entity';
import { INotificationType } from './i-notification-type';
import { ILocation } from '@boma/supplier-portal/shared/entities';
import { IUser } from '@boma/client-shared';

export interface INotificationTrigger {
  id: string;
  entity: IBasicEntity;
  notificationType: INotificationType;
  location?: ILocation;
  targetId?: string;
  users: INotificationTriggerUser[];
  condition: string;
}

export interface INotificationTriggerUser {
  user: IUser;
  enabled: boolean;
}

export interface IUserNotificationDetails {
  user: IUser;
  notificationTriggers: IUserNotificationTrigger[];
}

export interface IUserNotificationTrigger {
  id: string;
  entity: IBasicEntity;
  enabled: boolean;
  notificationType: INotificationType;
  location?: ILocation;
  targetId?: string;
  users: INotificationTriggerUser[];
  condition: string;
}
